

























































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import MemberType from "@/models/porposal/memberType.Model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import UserService from '../../../services/user.service';
import { PermissionValue } from '../../../enums/PermissionValue';
@Component
export default class MemberTypeTableComponent extends GenericBTable<MemberType> {

  created() {
    this.permissionValue = PermissionValue.TIPOMIEMBRO;
    this.tableConfig.controller = "MemberTypes";
    this.tableConfig.actions.customTemplate = true;
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.name", true);
    this.tableConfig.insertColumns(name);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }
}
